export default __webpack_public_path__ + "static/media/NevaLovelace.117dd362.png";